import { roles } from 'src/app/shared/lists/roles';
import { environment } from "src/environments/environment";
import { Company, COMPANY_STATE, FRAGA_CATALOG } from "../../../../interface/company";
import { SideMenu } from "../../../../interface/side-menu";
import { User } from "../../../../interface/user";
import { BOOLEAN_TWO } from 'src/app/shared/common-enums/boolean-two';

export const MEKANIC_MENU: (company: Company, user: User) => SideMenu[] = (company, user) => {

  const isContaAzul = Number(company.currentState) === COMPANY_STATE.CONTA_AZUL;

  const menus: SideMenu[] = [
    // company
    {
      component: 'company',
      href: ['/company'],
      icon: 'domain',
      isTopLevel: true,
    },
    {
      component: 'favorites',
      isTopLevel: true,
      icon: 'star',
      children: [
        {
          component: 'configure',
          href: ['company', company.id, 'quick-access']
        }
      ]
    },
    // gestao do patio
    {
      component: "company-management",
      isTopLevel: true,
      icon: "work",
      blockedRoles: [roles.mechanic.id],
      children: [
        // dashboard kpi
        {
          component: 'kpi-dashboard',
          profileModule: "KPI",
          icon: 'dashboard',
          blockedRoles: [roles.mechanic.id],
          href: ['company', company.id, 'kpi']
        },
        {
          component: 'clients',
          profileModule: "CLIENT",
          blockedRoles: [roles.mechanic.id],
          icon: 'assignment_ind',
          href: ['company', company.id, 'clients'],
          shadows: ['client-detail']
        },
        {
          component: 'suppliers',
          profileModule: "SUPPLIER",
          blockedRoles: [roles.mechanic.id],
          icon: 'local_shipping',
          href: ['company', company.id, 'suppliers'],
          shadows: ['supplier-detail']
        },
        {
          component: 'calendar',
          profileModule: "CALENDAR",
          icon: 'today',
          blockedRoles: [roles.mechanic.id],
          href: ['company', company.id, 'calendar']
        },
        {
          component: 'indicators',
          profileModule: "BUSINESS_MANAGEMENT",
          blockedRoles: [roles.mechanic.id, roles.consultant.id],
          icon: 'pie_chart',
          children: [{
            component: 'info',
            href: ['company', company.id, 'dashboard'],
            profileRule: "BUSINESS_MANAGEMENT.read",
            shadows: [
              'info',
              'revenue-indicators-sales',
              'ranking-sellers-average-ticket',
              'ranking-sellers-clients-served',
              'ranking-sellers-sales',
              'revenue-indicators-average-ticket',
              'revenue-indicators-groups',
            ]
          }]
        },
        {
          component: 'users',
          profileModule: "USER",
          blockedRoles: [roles.mechanic.id, roles.consultant.id],
          icon: 'people',
          children: [
            {
              profileRule: "USER.REGISTERED_USERS.read",
              component: 'user-list',
              href: ['company', company.id, 'users'],
              shadows: ['user-detail'],
            },

            // access-profiles
            {
              profileRule: "USER.ACCESS_CONTROL.read",
              component: 'access-profile',
              href: ['company', company.id, 'access-profile'],
              shadows: ['access-profile-edit']
            }
          ]
        },
        {
          component: 'CRM',
          profileModule: "CRM",
          blockedRoles: [roles.mechanic.id],
          icon: 'reduce_capacity',
          children: [
            {
              component: 'lead-list',
              profileRule: "CRM.leads.read",
              href: ['company', company.id, 'crm', 'lead-list']
            },
            {
              component: 'contact-list',
              profileRule: "CRM.contacts.read",
              href: ['company', company.id, 'crm', 'contact-list']
            },
            {
              component: 'survey-list',
              profileRule: "RECORDS.surveys.read",
              href: ['company', company.id, 'records', 'survey-list'], shadows: ['survey-edit']
            },
          ]
        },
        ...(company.discountControl === BOOLEAN_TWO.TRUE ? [{
          component: 'discount-control',
          blockedRoles: [roles.mechanic.id, roles.consultant.id],
          profileModule: "DISCOUNT_CONTROL",
          icon: 'notifications_active',
          href: ['company', company.id, 'discount-control']
        }] : []),
        {
          component: 'company-management-records',
          profileModule: "RECORDS",
          blockedRoles: [roles.mechanic.id, roles.consultant.id],
          icon: 'note_add',
          children: [
            {
              component: 'calendar-class',
              profileRule: "RECORDS.calendarTypes.read",
              href: ['company', company.id, 'calendar', 'classList']
            },
            {
              component: 'holidays-list',
              profileRule: "RECORDS.holidays.read",
              href: ['company', company.id, 'records', 'holidays']
            },
            ...(Boolean(company.tokenWhats) ? [{
              component: 'control-messages',
              profileRule: "RECORDS.controlMessages.read",
              href: ['company', company.id, 'records', 'control-messages']
            }] : []),
          ]
        }
      ]
    },
    // quick access of favorite menus
    {
      component: "parts-and-stock",
      icon: "settings",
      blockedRoles: [roles.mechanic.id],
      isTopLevel: true,
      children: [
        {
          component: 'parts',
          profileModule: "PART",
          blockedRoles: [roles.mechanic.id],
          icon: 'settings',
          href: ['company', company.id, 'parts'],
          shadows: ['part-detail'],
          children: [
            {
              component: 'maintenance',
              profileRule: "PART.update",
              href: ['company', company.id, 'parts', 'maintenance']
            },
            // ...(company.fragaCatalog && (company.fragaCatalog !== FRAGA_CATALOG.BLOCKED) ? [{
            //   component: 'parts-consult',
            //   href: ['company', company.id, 'parts-consult'],
            //   profileRule: "PART.partsConsult"
            // }] : []), fraga will be free for a while, so I just comment out this code and don't delete it
            {
              component: 'parts-consult',
              href: ['company', company.id, 'parts-consult'],
              profileRule: "PART.partsConsult"
            }
          ]
        },
        {
          component: 'stock',
          profileModule: "STOCK",
          blockedRoles: [roles.mechanic.id],
          icon: 'widgets',
          href: ['company', company.id, 'stock'],
          children: [
            {
              component: 'transfer-list',
              profileRule: "STOCK.read",
              href: ['company', company.id, 'stock', 'transfer']
            }
          ]
        },
        {
          component: 'parts-records',
          profileModule: "RECORDS",
          blockedRoles: [roles.mechanic.id, roles.consultant.id],
          icon: 'note_add',
          children: [
            {
              component: 'group-list',
              profileRule: "RECORDS.groups.read",
              href: ['company', company.id, 'records', 'groups']
            },
            {
              component: 'subgroup-list',
              profileRule: "RECORDS.subgroups.read",
              href: ['company', company.id, 'records', 'subgroups']
            },
            {
              component: 'brand-list',
              profileRule: "RECORDS.brands.read",
              href: ['company', company.id, 'records', 'brands']
            },
            {
              component: 'application-list',
              profileRule: "RECORDS.applications.read",
              href: ['company', company.id, 'records', 'applications']
            },
          ]
        }
      ]
    },
    {
      component: "workshop",
      icon: "warehouse",
      isTopLevel: true,
      children: [
        {
          component: 'karban',
          profileModule: "YARD",
          icon: 'home',
          blockedRoles: [],
          href: ['company', company.id, 'home']
        },
        {
          component: 'budgets',
          profileModule: "OS",
          blockedRoles: [roles.mechanic.id],
          icon: 'assignment',
          shadows: ['budget-create'],
          children: [
            {
              component: 'budget',
              shadows: ['budget_detail', 'ro_create'],
              profileRule: "OS.list.budget",
              href: ['company', company.id, 'os', 'budget']
            },
            {
              component: 'rejected',
              shadows: ['rejected_detail'],
              profileRule: "OS.list.rejectedBudget",
              href: ['company', company.id, 'os', 'rejected']
            },
            {
              component: 'closed-budget',
              shadows: ['closed-budget_detail'],
              profileRule: "OS.list.closedBudget",
              href: ['company', company.id, 'os', 'closed-budget']
            }
          ]
        },
        {
          component: 'ro',
          profileModule: "OS",
          blockedRoles: [roles.mechanic.id],
          icon: 'assignment_turned_in',
          shadows: ['ro-create'],
          children: [
            {
              component: 'opened',
              profileRule: "OS.list.openedRo",
              shadows: ['opened_detail'],
              href: ['company', company.id, 'os', 'opened']
            },
            {
              component: 'closed',
              profileRule: "OS.list.closedRo",
              shadows: ['closed_detail'],
              href: ['company', company.id, 'os', 'closed']
            },
            {
              component: 'ended',
              profileRule: "OS.list.endedRo",
              shadows: ['ended_detail'],
              href: ['company', company.id, 'os', 'ended']
            }
          ]
        },
        {
          component: 'labors',
          profileModule: "LABOR",
          blockedRoles: [roles.mechanic.id],
          svgIcon: 'labor',
          shadows: ['labor-detail'],
          children: [
            {
              component: 'labors',
              shadows: ['labor_list'],
              profileRule: "LABOR.read",
              href: ['company', company.id, 'labors'],
            },
            {
              component: 'labor-maintenance',
              profileRule: "LABOR.maintenance",
              shadows: ['labor_maintenance'],
              href: ['company', company.id, 'labors', 'maintenance'],
            }
          ]
        },
        {
          component: environment.agro ? 'machines' : (environment.nautical ? 'boats' : 'vehicles'),
          profileModule: "VEHICLE",
          blockedRoles: [roles.mechanic.id],
          icon: environment.agro ? "agriculture" : (environment.nautical ? "sailing" : "directions_car"),
          href: ['company', company.id, 'vehicles'],
          shadows: ['vehicle-detail', 'search-vehicle']
        },
        {
          component: 'mechanical-control-service',
          profileModule: "NOTATION",
          icon: 'handyman',
          href: ['company', company.id, 'mechanical'],
          shadows: ['mechanical-service'],
          children: [
            {
              component: 'app-page-dash-labors',
              href: ['company', company.id, 'mechanical', 'dashboard'],
              profileRule: "NOTATION.dashboard",
              blockedRoles: [roles.mechanic.id, roles.consultant.id]
            }
          ]
        },
        {
          component: 'workshop-records',
          profileModule: "RECORDS",
          blockedRoles: [roles.mechanic.id, roles.consultant.id],
          icon: 'note_add',
          children: [
            {
              component: 'group-list',
              profileRule: "RECORDS.groups.read",
              href: ['company', company.id, 'records', 'groups']
            },
            {
              component: 'carte-list',
              profileRule: "RECORDS.cartes.read",
              href: ['company', company.id, 'records', 'carte-list']
            },
            {
              component: 'checklist',
              profileRule: "RECORDS.mkgChecklist.read",
              href: ['company', company.id, 'records', 'checklist']
            },
            {
              component: 'ro-types',
              profileRule: "RECORDS.OStypes.read",
              href: ['company', company.id, 'records', 'ro-types']
            },
            {
              component: 'reject-types',
              href: ['company', company.id, 'records', 'reject-types'],
              profileRule: "RECORDS.rejectTypes.read"
            },
            {
              component: 'checklist-models',
              profileRule: "RECORDS.checklistByModel.read",
              href: ['company', company.id, 'records', 'checklist-model']
            },
            {
              component: 'custom-state-list',
              profileRule: "RECORDS.additionalOSStates.read",
              href: ['company', company.id, 'records', 'custom-states']
            },
            {
              component: 'custom-state-budget-list',
              profileRule: "RECORDS.additionalBudgetStates.read",
              href: ['company', company.id, 'records', 'custom-states-budget']
            },
            {
              component: 'labor-types-list',
              profileRule: "RECORDS.laborTypes.read",
              href: ['company', company.id, 'records', 'labor-types']
            },
            {
              component: 'tags',
              profileRule: "RECORDS.tags.read",
              href: ['company', company.id, 'records', 'tags']
            },
            ...(company.customOsPdf ? [{
              component: 'pdf-template-list',
              profileRule: "RECORDS.pdf_templates.read",
              href: ['company', company.id, 'records', 'pdf-templates']
            }] : []),
          ]
        },
        {
          component: "os-audit",
          profileRule: "OS.audit",
          icon: "manage_search",
          blockedRoles: [roles.mechanic.id, roles.consultant.id, roles.manager.id],
          href: ['company', company.id, 'os', 'audit']
        }
      ]
    },
    {
      component: "orders-module",
      isTopLevel: true,
      icon: 'ballot',
      blockedRoles: [roles.mechanic.id],
      children: [
        {
          component: 'orders',
          profileModule: "ORDER",
          blockedRoles: [roles.mechanic.id],
          icon: 'ballot',
          href: ['company', company.id, 'order'],
          shadows: ['order-detail']
        },
        {
          component: 'pdv',
          profileRule: "ORDER.create",
          blockedRoles: [roles.mechanic.id],
          icon: 'add_shopping_cart',
          href: ['company', company.id, 'order', 'add'],
          queryParams: { type: "pdv" },
          shadows: ['pdv']
        }
      ]
    },
    {
      component: "workshop-sales",
      icon: "sell",
      blockedRoles: [roles.mechanic.id],
      isTopLevel: true,
      children: [
        {
          component: 'invoice-module',
          profileModule: "INVOICE",
          blockedRoles: [roles.mechanic.id],
          icon: 'receipt',
          children: [
            {
              component: 'invoices',
              profileRule: "INVOICE.importXML",
              href: ['company', company.id, 'invoices'],
              shadows: ['invoice-detail', 'devolution'],

            },
            ...(company.importador === 2 ? [{
              component: 'dfe-list',
              profileRule: "INVOICE.dfe",
              href: ['company', company.id, 'invoices', 'dfe']
            }] : []),
            {
              component: 'xml',
              profileRule: "INVOICE.importXML",
              href: ['company', company.id, 'invoices', 'xml']
            },
            {
              component: 'widthoutXML',
              profileRule: "INVOICE.importWidthoutXML",
              href: ['company', company.id, 'invoices', 'nf'],
              queryParams: { gerencial: "OIM" }
            },
            {
              component: 'sintegra',
              profileRule: "INVOICE.sintegra",
              href: ['company', company.id, 'sintegra'],
              shadows: ['sintegra-detail']
            },
            {
              component: "audit-invoices",
              profileRule: "INVOICE.audit",
              blockedRoles: [roles.mechanic.id, roles.consultant.id, roles.manager.id],
              href: ['company', company.id, 'invoices', 'audit'],
            }
          ]
        },
        {
          component: "workshop-sales-records",
          profileModule: "RECORDS",
          blockedRoles: [roles.mechanic.id, roles.consultant.id],
          icon: 'note_add',
          children: [
            {
              component: 'operations',
              profileRule: "RECORDS.operations.read",
              blockedRoles: [roles.mechanic.id, roles.consultant.id],
              href: ['company', company.id, 'operations'],
              shadows: ['operation-detail']
            },
            {
              component: 'origin-list',
              profileRule: "RECORDS.origins.read",
              href: ['company', company.id, 'records', 'origin-list']
            },
          ]
        }
      ]
    },
    {
      component: 'cash',
      blockedRoles: [roles.mechanic.id, roles.consultant.id],
      icon: 'local_atm',
      isTopLevel: true,
      children: [
        {
          component: 'cash-title',
          profileRule: "FINANCIAL.titles.read",
          icon: "attach_money",
          href: ['company', company.id, 'financial', 'cash-title'],
          shadows: ['cash-title-detail']
        },
        {
          component: 'receipt',
          profileRule: "FINANCIAL.cashier.read",
          icon: "account_balance_wallet",
          href: ['company', company.id, 'financial', 'receipt'],
          shadows: ['closed-cashier']
        },
        {
          component: 'banks',
          profileRule: "FINANCIAL.banks.read",
          icon: "account_balance",
          href: ['company', company.id, 'financial', 'banks']
        },
        {
          component: 'conciliation',
          profileRule: "FINANCIAL.conciliation.read",
          icon: "sync",
          href: ['company', company.id, 'financial', 'conciliation'],
          shadows: ['conciliation-detail']
        },
        {
          component: 'detached',
          profileRule: "FINANCIAL.detached.read",
          icon: "document_scanner",
          href: ['company', company.id, 'financial', 'detached']
        },
        {
          component: 'cash-flow-control',
          profileRule: "FINANCIAL.cash-flow-control.read",
          icon: "bar_chart",
          href: ['company', company.id, 'financial', 'cash-flow-control'],
        },
        {
          component: 'title-logs',
          hideInProduction: true,
          icon: "manage_search",
          href: ['company', company.id, 'financial', 'title-logs']
        },
        {
          component: 'cashier-logs',
          hideInProduction: true,
          icon: "manage_search",
          href: ['company', company.id, 'financial', 'cashier-logs']
        },
        ...(company.boletos === 2 && !isContaAzul ? [{
          component: 'boletos',
          profileRule: "FINANCIAL.boleto.read",
          shadows: ['boleto_pjbank'],
          icon: "payment",
          href: ['company', company.id, 'financial', 'boletos'],
        }] : []),
        {
          component: "cash-records",
          icon: "note_add",
          profileModule: "RECORDS",
          children: [
            {
              component: 'bank-list',
              profileRule: "RECORDS.banks.read",
              href: ['company', company.id, 'records', 'banks']
            },
            {
              component: 'payment-condition-list',
              profileRule: "RECORDS.paymentConditions.read",
              href: ['company', company.id, 'records', 'payment-conditions']
            },
            {
              component: 'cashier-event-list',
              profileRule: "RECORDS.events.read",
              href: ['company', company.id, 'records', 'cashier-events']
            },
            {
              component: 'groups-by-expense-type-list',
              profileRule: "RECORDS.expenseGroups.read",
              href: ['company', company.id, 'records', 'groups-by-expense-type']
            },
            {
              component: 'subgroup-by-expense-type-list',
              profileRule: "RECORDS.expenseSubgroups.read",
              href: ['company', company.id, 'records', 'subgroup-by-expense-type']
            },
            {
              component: 'title-type-list',
              profileRule: "RECORDS.titleTypes.read",
              href: ['company', company.id, 'records', 'title-types']
            },
            {
              component: 'expense-list',
              profileRule: "RECORDS.expenseTypes.read",
              href: ['company', company.id, 'records', 'expense-types']
            },
            {
              component: 'status-title-list',
              profileRule: 'RECORDS.statusTitle.read',
              href: ['company', company.id, 'records', 'status-title']
            },
            ...(company.boletos === 2 && !isContaAzul ? [{
              component: 'pjbank-accounts',
              profileRule: "RECORDS.boleto_accounts.read",
              shadows: ['pj_bank'],
              href: ['company', company.id, 'records', 'pjbank-accounts']
            }] : []),
            ...(company.boletos === 2 && !isContaAzul ? [{
              component: 'boleto-settings',
              profileRule: "RECORDS.boleto_settings.read",
              shadows: ['boleto_settings_pjbank'],
              href: ['company', company.id, 'records', 'boleto-settings']
            }] : [])
          ]
        }
      ]
    },
    {
      component: 'reports',
      profileModule: "REPORTS",
      blockedRoles: [roles.mechanic.id, roles.consultant.id],
      icon: 'description',
      isTopLevel: true,
      children: [
        {
          component: 'budget-prospection',
          profileRule: 'REPORTS.prospection',
          href: ['company', company.id, 'reports', 'budget-prospection']
        },
        {
          component: 'commissions',
          profileRule: 'REPORTS.commissions',
          href: ['company', company.id, 'reports', 'commissions']
        },
        {
          component: 'dashboard',
          profileRule: 'REPORTS.dashboard',
          href: ['company', company.id, 'reports', 'dashboard']
        },
        {
          component: 'sales',
          profileRule: 'REPORTS.sales',
          href: ['company', company.id, 'reports', 'sales']
        },
        {
          component: 'user-sales',
          profileRule: 'REPORTS.userSales',
          href: ['company', company.id, 'reports', 'user-sales']
        },
        {
          component: 'profits',
          profileRule: 'REPORTS.profits',
          href: ['company', company.id, 'reports', 'profits']
        },
        {
          component: 'profits-by-os',
          profileRule: 'REPORTS.profitsByOs',
          href: ['company', company.id, 'reports', 'profits-by-os']
        },
        {
          component: 'mechanic-time',
          profileRule: 'REPORTS.mechanicTime',
          href: ['company', company.id, 'reports', 'mechanic-time']
        },
        {
          component: 'dre',
          profileRule: 'REPORTS.dre',
          href: ['company', company.id, 'reports', 'dre']
        },
        {
          component: 'os-vehicle-history',
          profileRule: 'REPORTS.osVehicleHistory',
          href: ['company', company.id, 'reports', 'os-vehicle-history']
        },
        {
          component: 'vehicle-history',
          profileRule: 'REPORTS.vehicleHistory',
          href: ['company', company.id, 'reports', 'vehicle-history']
        },
        {
          component: 'os-history',
          profileRule: 'REPORTS.osHistory',
          href: ['company', company.id, 'reports', 'os-history']
        },
        {
          component: 'infocar-queries',
          profileRule: "REPORTS.infocarQueries",
          href: ['company', company.id, 'reports', 'infocar-queries']
        },
        {
          component: 'sales-analysis',
          profileRule: "REPORTS.salesAnalysis",
          href: ['company', company.id, 'reports', 'sales-analysis']
        },
        {
          component: 'parts-report',
          profileRule: "REPORTS.parts",
          href: ['company', company.id, 'reports', 'parts-reports']
        },
        {
          component: 'labors-report',
          profileRule: "REPORTS.laborsReports",
          href: ['company', company.id, 'reports', 'labors-reports']
        },
        ...(company.useDiagwebMaintenanceModule ? [{
          component: 'diagweb-maintenance-use',
          profileRule: "REPORTS.diagwebMaintenanceUse",
          href: ['company', company.id, 'reports', 'diagweb-maintenance-use'],
        }] : [])
      ]
    },
    {
      component: 'settings',
      blockedRoles: [roles.mechanic.id],
      icon: 'build',
      href: ['company', company.id, 'settings'],
      isTopLevel: true,
      children: [
        {
          component: 'import-csv-xls',
          href: ['company', company.id, 'settings', 'import-ibpt'],
          profileRule: "SETTINGS.importCsvXls",
          blockedRoles: [roles.mechanic.id, roles.manager.id, roles.consultant.id]
        },
        ...(isContaAzul ? [{
          component: 'conta-azul-config',
          href: ['company', company.id, 'settings', 'conta-azul'],
          profileRule: "SETTINGS.contaAzul",
          blockedRoles: [roles.mechanic.id, roles.consultant.id]
        }] : []),
      ]
    },
    {
      component: 'logs',
      isTopLevel: true,
      hideInProduction: true,
      icon: 'view_timeline',
      children: [
        {
          component: 'logs-diagweb',
          hideInProduction: true,
          href: ['company', company.id, 'logs', 'logs-diagweb']
        },
        ...(company.boletos === 2 && !isContaAzul ? [{
          component: 'boleto-logs',
          hideInProduction: true,
          href: ['company', company.id, 'financial', 'boleto-logs']
        }] : []),
      ]
    },
    {
      component: 'support',
      icon: 'video_library',
      href: ['company', company.id, 'support'],
      isTopLevel: true,
      profileModule: "SUPPORT"
    },
  ];

  if (Array.isArray(user.quickAccess) && user.quickAccess.length) {
    const favoriteIndex = menus.findIndex(m => m.component === 'favorites');
    const configureChild = menus[favoriteIndex].children.pop();

    const quickChilds: SideMenu['children'] = [];

    for (const quick of user.quickAccess) {
      let child: SideMenu['children'][0];

      for (const menu of menus) {
        if (menu.children?.length) {
          if (child) {
            break;
          }

          if (menu.component === quick) {
            child = menu;
            break;
          }

          for (const menuChild of menu.children) {
            if (child) {
              break;
            }

            if (menuChild.component === quick) {
              child = menuChild;
              break;
            } else if (menuChild.children?.length) {
              for (const menuGrandchild of menuChild.children) {
                if (child) {
                  break;
                }

                if (menuGrandchild.component === quick) {
                  child = menuGrandchild;
                  break;
                }
              }
            }
          }
        }
      }

      if (child) {
        quickChilds.push(child);
      }
    }

    quickChilds.push(configureChild);

    menus[favoriteIndex].children = quickChilds;
  }

  return menus
}

export function formatMenus(menus: SideMenu[]): SideMenu[] {
  for (let menu of menus) {
    let topLevelProfileModule: string[] = [];
    for (let childMenu of menu?.children ?? []) {
      let profileModule = childMenu.profileModule;

      if (!profileModule && childMenu.profileRule) {
        profileModule = childMenu.profileRule?.split(".")[0];
      } else if (!profileModule && childMenu.children && childMenu.children?.length) {
        for (let subMenu of childMenu.children) {
          profileModule = subMenu.profileRule?.split(".")[0];

          if (profileModule) {
            if (!topLevelProfileModule.includes(profileModule)) {
              topLevelProfileModule.push(profileModule);
            }
          }
        }
      }

      if (profileModule) {
        if (!topLevelProfileModule.includes(profileModule)) {
          topLevelProfileModule.push(profileModule);
        }
      }
    }

    if (topLevelProfileModule.length > 1) {
      menu["topLevelProfileModule"] = topLevelProfileModule;
    }
  }

  return menus;
}
